<template>
  <header
      class="fixed left-0 top-0 w-full bg-white px-4 py-3 lg:px-8 xl:px-18 lg:py-6 flex items-center justify-between z-50 bg-white border-b border-light-gray"
  >
    <router-link to="/">
      <Logo/>
    </router-link>
    <div class="flex items-center">
      <nav>
        <ul
            v-if="
            !showButtonsAttendees &&
              !isEditingOrder &&
              !isEditingSuborder &&
              !isCatererEditing &&
              !isEventPlannerEditing
          "
            class="hidden lg:flex lg:items-center"
        >
          <li v-if="isAuthenticated" class="link">
            <router-link class="font-semibold mr-10" to="/orders"
            >My Projects
            </router-link
            >
          </li>
          <li v-if="isAuthenticated" class="link">
            <router-link class="font-semibold mr-10" to="/events"
            >My Boxes
            </router-link
            >
          </li>
          <li v-if="isAuthenticated && isCaterer" class="link">
            <router-link
                :to="{ name: 'caterer.dashboard' }"
                class="font-semibold mr-10"
            >My Catering Business
            </router-link
            >
          </li>
          <li v-if="isAuthenticated && isEventPlanner" class="link">
            <router-link
                :to="{ name: 'event-planner.dashboard' }"
                class="font-semibold mr-10"
            >My Event Business
            </router-link
            >
          </li>
          <li v-if="!isAuthenticated" class="link">
            <router-link class="font-semibold mr-10" to="/how-it-works"
            >How It Works
            </router-link
            >
          </li>
          <li class="link">
            <a class="font-semibold mr-10 w-12 text-center" href="#" @click="createOrder">
              <span v-if="create_buildabox_order_loading">Please wait...</span>
              <span v-else>Order from BuildaBox</span>
            </a
            >
          </li>
          <li class="link">
            <router-link
                :to="{ name: 'segmentation-wizard' }"
                class="font-semibold mr-10"
            >Produce an Event
            </router-link
            >
          </li>
          <!--          <li v-if="!isAuthenticated" class="link">-->
          <!--            <router-link to="/pricing" class="font-semibold mr-10"-->
          <!--              >Pricing</router-link-->
          <!--            >-->
          <!--          </li>-->
          <li v-if="!isAuthenticated" class="link">
            <router-link class="font-semibold mr-10" to="/auth/sign-in"
            >Sign In
            </router-link
            >
          </li>
          <li v-if="!isAuthenticated">
            <router-link to="/auth/sign-up">
              <button class="btn btn-primary rounded-lg font-semibold px-8">
                Sign Up
              </button>
            </router-link>
          </li>
        </ul>

        <!-- Edit order save/cancel buttons -->
        <div v-if="isEditingOrder" class="sm:flex sm:items-center hidden">
          <button
              v-if="!isOrderCompleted"
              class="btn btn-secondary rounded-lg font-semibold px-6 mr-2"
              @click="onClickCancel"
          >
            Cancel
          </button>
          <LoadingButton
              v-if="!isOrderCompleted"
              :loading="$store.state.isSavingCurrentOrder"
              class="btn-primary px-6 w-40"
              @click="saveCurrentOrderAndExit"
          >
            Save & Exit
          </LoadingButton>
        </div>
        <!-- ### -->

        <!-- Edit suborder save/cancel buttons -->
        <div v-if="isEditingSuborder" class="sm:flex sm:items-center hidden">
          <template v-if="isAttendeeSuborderCreated">
            <button
                class="btn btn-secondary rounded-lg font-semibold px-6 mr-2"
                @click="attendeeSaveAndExit"
            >
              Cancel
            </button>
            <LoadingButton
                :loading="loading"
                class="btn-primary px-6"
                @click="attendeeSaveAndExit"
            >
              Save & Exit
            </LoadingButton>
          </template>
        </div>
        <!-- ### -->

        <!-- Caterer Signup Process save/cancel buttons -->
        <div v-if="isCatererEditing" class="sm:flex sm:items-center hidden">
          <button
              class="btn btn-secondary rounded-lg font-semibold px-6 mr-2"
              @click="$router.push('/')"
          >
            Cancel
          </button>
          <LoadingButton
              :loading="loading"
              class="btn-primary px-6"
              @click="catererSaveAndExit"
          >
            Save & Exit
          </LoadingButton>
        </div>
        <!-- ### -->

        <!-- Event Planner Signup Process save/cancel buttons -->
        <div
            v-if="isEventPlannerEditing"
            class="sm:flex sm:items-center hidden"
        >
          <button
              class="btn btn-secondary rounded-lg font-semibold px-6 mr-2"
              @click="$router.push('/')"
          >
            Cancel
          </button>
          <LoadingButton
              :loading="loading"
              class="btn-primary px-6"
              @click="eventPlannerSaveAndExit"
          >
            Save & Exit
          </LoadingButton>
        </div>
        <!-- ### -->
      </nav>

      <div class="flex items-center  ml-4">
        <div v-if="isAuthenticated" class="relative">
          <img
              :src="avatarUrl"
              alt="Avatar"
              class="w-10 h-10 rounded-full cursor-pointer border object-cover"
              @click="popupOpen = !popupOpen"
          />
          <ul
              v-if="popupOpen"
              class="absolute w-40 rounded-lg bg-white shadow-card popup"
          >
            <li
                class="p-4 text-center cursor-pointer"
                @click="goto('/account')"
            >
              Account
            </li>
            <li
                class="p-4 text-center cursor-pointer"
                @click="goto('/account/section-subscription')"
            >
              Subscription
            </li>
            <li
                class="p-4 text-center cursor-pointer"
                @click="goto('/account/section-creditcard')"
            >
              Credit Card
            </li>
            <li
                class="p-4 text-center cursor-pointer"
                @click="goto('/account/section-invoices')"
            >
              Invoices
            </li>
            <li class="p-4 text-center cursor-pointer" @click="_signOut">
              Sign out
            </li>
          </ul>
        </div>
      </div>

      <div
          class="mobile-menu-btn w-8 cursor-pointer visible lg:hidden ml-4"
          @click="toggleBurgerMenu()"
      >
        <template v-if="!drawerState">
          <div class="border-b border-4 rounded border-primary mb-1"></div>
          <div class="border-b border-4 rounded border-primary mb-1"></div>
          <div class="border-b border-4 rounded border-primary"></div>
        </template>

        <template v-else>
          <div
              class="border-b border-4 rounded border-primary mb-1 transform rotate-45 relative"
              style="top: 0.54rem"
          ></div>
          <div
              class="border-b border-4 rounded border-primary mb-1 transform -rotate-45"
          ></div>
        </template>
      </div>
    </div>
    <transition name="fade">
      <Notification v-if="notificationShown">
        <template v-slot:heading>
          Whoops
        </template>
        <template v-slot:message>
          Could not save the order. Please, check errors and try again.
        </template>
        <template v-slot:button>
          <button
              class="btn btn-primary font-semibold rounded-lg px-16"
              type="button"
              @click="notificationShown = false"
          >
            I understand
          </button>
        </template>
      </Notification>
    </transition>
  </header>
</template>

<script>
import Logo from './Logo'
import { mapActions, mapGetters } from 'vuex'
import LoadingButton from './LoadingButton'
import Notification from '../Notification'
import { EventBus } from '@/utils/event-bus'
import Api from '@/api/api_v1.0'
import api_v1 from '@/api/api_v1.0'
import Spinner from '@/components/common/Spinner'

export default {
  components: {
    Spinner,
    Notification,
    LoadingButton,
    Logo
  },
  data () {
    return {
      isCatererEditing              : false,
      isEventPlannerEditing         : false,
      isMenuOpen                    : false,
      popupOpen                     : false,
      notificationShown             : false,
      loading                       : false,
      isAttendeeSuborderCreated     : false,
      caterer                       : {
        payments: []
      },
      create_buildabox_order_loading: false
    }
  },
  async created () {
    this.$root.$on('attendeeSubOrderCreated', this.setAttendeeSuborderCreated)
    await this.getCatererInfo('buildabox')
  },
  beforeDestroy () {
    this.$root.$off('attendeeSubOrderCreated', this.setAttendeeSuborderCreated)
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'personalDetails',
      'canSaveCurrentStep',
      'orderDetailsValid',
      'currentStep',
      'orderComplete',
      'roles',
      'drawerState'
    ]),

    isCaterer () {
      return this.roles?.includes('caterer')
    },

    isEventPlanner () {
      return this.roles?.includes('event_planner')
    },

    avatarUrl () {
      return (
          this.personalDetails?.avatar ||
          require('@/assets/images/default-avatar.png')
      )
    },

    showButtonsAttendees () {
      const {
              meta: { showHeaderControlsForAttendees }
            } = this.$route
      return !!showHeaderControlsForAttendees
    },
    isEditingOrder () {
      return this.$route.matched.some(({ name }) => name === 'orders.edit')
    },
    isEditingSuborder () {
      return this.$route.matched.some(({ name }) => name === 'events.edit')
    },
    isOrderCompleted () {
      return this.$route.name === 'orders.edit.success'
    }
  },
  methods : {
    ...mapActions([
      'signOut',
      'setRedirectAfterAuthUrl',
      'setAuthBehaviorType',
      'setOrderBehaviorType',
      'saveOrderAndExit',
      'validateCurrentStep',
      'shouldRestoreOrder',
      'setSuccessMessage'
    ]),
    async createOrder () {
      this.create_buildabox_order_loading = true
      const orderResponse = await api_v1.createBuildaboxOrder()
      await this.$store.commit('setCurrentEditingOrder', orderResponse.data)
      await this.$router.push(`/orders/${orderResponse.data.uuid}/edit`)
      this.create_buildabox_order_loading = false
    },
    async getCatererInfo (slug) {
      const response = await Api.getCatererBySlug(slug)
      this.caterer = response.data
    },
    setAttendeeSuborderCreated () {
      this.isAttendeeSuborderCreated = true
    },
    cancelOrder () {
      this.shouldRestoreOrder(false)
      this.$router.push('/')
    },
    async attendeeSaveAndExit () {
      await this.$router.push('/events')
    },
    _signOut () {
      this.signOut()
      this.popupOpen = false
      window.location.reload()
    },
    goto (url) {
      this.popupOpen = false
      this.$router.push(url)
    },
    onClickCancel () {
      if (this.$store.getters.isAuthenticated) {
        this.$router.push('/orders')
      } else {
        this.$router.push('/')
      }
    },
    saveCurrentOrderAndExit () {
      EventBus.$emit('saveCurrentEditingOrder')
    },

    toggleBurgerMenu () {
      this.$store.commit('setDrawerState', !this.$store.state.drawerState)
    },

    catererSaveAndExit () {
      this.$root.$emit('catererProcessSaveExit')
    },

    eventPlannerSaveAndExit () {
      this.$root.$emit('eventPlannerProcessSaveExit')
    }
  },
  watch   : {
    $route (to, from) {
      this.isCatererEditing = to.path.includes('caterer/my-business') ?? true
      this.isEventPlannerEditing =
          to.path.includes('event-planner/my-business') ?? true
    }
  }
}
</script>

<style lang="scss" scoped>
.link {
  transition: all 0.2s;

  &:active {
    transform: scale(0.98);
  }
}

.popup {
  left: -100px;
  top: 110%;
}
</style>
